import React from 'react'

const WorkExperienceCard = ({ data }) => {
  return (
    <div className='border rounded border-primary mt-3 p-3'>
      <h5 className='mb-0'>{data.title}</h5>

      <div className='text-start'>
        <div dangerouslySetInnerHTML={{ __html: data.description }} />

        <h5 className='mb-2 text-underline'>Skills</h5>
        <div className='d-flex flex-wrap align-items-center'>
          {data?.skills?.length > 0 &&
            data.skills.map((item, i) => (
              <p
                className='rounded-pill py-1 px-3 me-2 bg-light text-primary'
                style={{ marginBottom: '10px' }}
                key={i}
              >
                {item.skill}
              </p>
            ))}
        </div>

        <div className='py-2'>
          <h5 className='mb-1 text-underline'>Responsibilities</h5>
          <div dangerouslySetInnerHTML={{ __html: data.responsibilities }} />
        </div>
      </div>
    </div>
  )
}

export default WorkExperienceCard